import BaseController from "vamos/cockpit/base/controller/type/BaseController";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";

export type NavConfig = {
  path?: string;
  tab?: string;
}
/**
 * @namespace vamos.cockpit.base.handler
 */
export default class NavigationHandler {
  private controller: BaseController;

  constructor(controller: BaseController) {
    this.controller = controller;
  }

  public onNavBack(): void {
    const controller = this.controller;
    let aHistory = controller.getSelectedTabContainerItem().data("history");
    let sHash;
    const oRouter = controller.getRouter();

    aHistory.pop();
    sHash = aHistory[aHistory.length - 1];

    if (sHash) {
      oRouter.getHashChanger().setHash(sHash);
      return;
    }

    const route = controller.getEmptyHistoryRoute();
    if (route) {
      this.navigateTo(route);
      return;
    }

    controller.getTabContainer().setSelectedItem("mainMenu");
  }

  public navigateTo(routeName: string, oConfig: NavConfig = {}, bIgnoreHistory = false): void {
    const controller = this.controller;

    const model = controller.getModel();
    if (model instanceof ODataModel) {
      model.resetChanges();
    }

    const oAdditionalInformation = {};
    const oRouter = controller.getRouter();

    const aItemHistory = controller.getSelectedTabContainerItem().data("history");

    if (oConfig.path) {
      oConfig.path = encodeURIComponent(oConfig.path);
    }

    if (!oConfig.tab) {
      oConfig.tab = controller.getSelectedTabContainerItem().getKey();
    }

    if (aItemHistory && !bIgnoreHistory) {
      aItemHistory.push(oRouter.getRoute(routeName).getURL(oConfig));
    }
    oRouter.navTo(routeName, oConfig, oAdditionalInformation, bIgnoreHistory);
  }
}